module.exports = __webpack_public_path__ + "img/Slide6.d1a990d6.jpg";